import React, { useEffect, useMemo, useState } from "react";
import { HeaderWrapper } from "./HeaderStyle";
import SearchIcon from "../../../../assets/icons/SearchIcon";

import SuperAdmin from "./SuperAdmin";
import { useDispatch, useSelector } from "react-redux";
import { setToggleMenu } from "../../redux/features/appMangerUtilitySlice";
import { useApiHook, UseAuthProvider } from "@bjsdistribution/tms-component-library";
import styled from "styled-components";
import { notification, Select } from "antd";
import NotificationPopup from "./NotificationPopup";

const Header = () => {
  const { userInfo, isSupplier } = UseAuthProvider();

  const dispatch = useDispatch();
  const { toggleMenu } = useSelector((state: any) => state.appMangerUtilitySlice);
  const [selectedClientId, setSelectedClientId] = useState();
  const [notificationModal, setNotificationModal] = useState(false);

  const { data: fetchedData, fetchData: fetchClientData } = useApiHook<any>({
    endpoint: "customer_config/client_static_data/",
    method: "GET",
  });

  const {
    fetchData: FetchData,
    error,
    loading,
  } = useApiHook<{
    data: any;
  }>({
    endpoint: "begin_login/sso/switch_organisation/",
    method: "PUT",
  });

  useEffect(() => {
    fetchClientData();
  }, []);

  useEffect(() => {
    if (fetchedData && fetchedData?.data) {
      const clientOptions = fetchedData?.data?.map((client: any) => ({
        label: client?.name,
        value: client?.client_id,
      }));

      const storedId = userInfo?.client_id;
      if (storedId) {
        const match = clientOptions?.find((option: any) => option?.value === storedId);
        if (match) {
          setSelectedClientId(match?.value);
        } else {
          setSelectedClientId(undefined);
        }
      } else {
        setSelectedClientId(undefined);
      }
    }
  }, [userInfo]);

  const toggleMenuFun = () => {
    dispatch(setToggleMenu(!toggleMenu));
  };

  const handleClientChange = async (value: any) => {
    try {
      if (value == userInfo?.client_id) return;
      const res = (await FetchData({
        payload: {
          organisation_id: value,
        },
      })) as {
        error?: string | null | undefined;
        [key: string]: any;
      };
      if (res?.code) {
        localStorage.clear();
        document.cookie = "id_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.reload();

        // setIsLogin(false);
        // navigate("/login");
      } else if (res?.error) {
        notification.error({
          message: "Error",
          description: error,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const client = useMemo(() => {
    return (
      fetchedData?.data &&
      fetchedData?.data?.map((client: any) => ({
        label: client?.name,
        value: client?.client_id,
      }))
    );
  }, [fetchedData?.data]);

  return (
    <HeaderWrapper>
      <header id="header" className="flex-justify">
        <div className="filterData flex-item-center">
          <span className="menu" onClick={toggleMenuFun}>
            {!toggleMenu && (
              <>
                <i></i>
                <i></i>
                <i></i>
              </>
            )}
            {toggleMenu && (
              <div className="navButton">
                <span className="line1"></span>
                <span className="line2"></span>
                <span className="line3"></span>
              </div>
            )}
          </span>
          <div className="textBoxWrapper">
            <input type="text" placeholder="Search for anything..."></input>
            <SearchIcon />
          </div>
        </div>
        <div className="rightPart flex-item-center">
          {!isSupplier && (
            <StyledSelect
              options={client || []}
              placeholder="Switch Client"
              onChange={handleClientChange}
              value={selectedClientId ?? undefined}
              loading={loading}
              disabled={loading}
              // mode="multiple"
              // allowClear
            />
          )}
          <NotificationPopup open={notificationModal} setOpen={setNotificationModal} isSupplier={isSupplier} />
          <SuperAdmin userInfo={userInfo} />
          {/* <Setting /> */}
        </div>
      </header>
    </HeaderWrapper>
  );
};

export default Header;

export const StyledSelect: any = styled(Select)`
  .ant-select-selector {
    display: flex;
    align-items: center;
    padding: 0px 10px;
    height: 30px;
    border-radius: 8px;
    min-width: 200px;
  }

  span.ant-select-selection-placeholder {
    color: #717196;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    font-family: "Open Sans", sans-serif;
    text-align: left;
  }

  .ant-select-prefix {
    display: flex;
  }

  span.ant-select-arrow.ant-select-arrow-loading svg {
    fill: #000;
  }
`;
